import { TextField } from '@mui/material';
import { forwardRef } from 'react';
import theme from '../../theme';

const CustomTextField = forwardRef(
  (
    {
      type = 'text',
      placeholder,
      error,
      helperText,
      disabled,
      sx: customSx,
      inputProps,
      ...restProps
    },
    ref,
  ) => {
    // date input에 대한 특별한 스타일
    const dateInputStyles =
      type === 'date'
        ? {
            '& .MuiOutlinedInput-root': {
              height: '46px !important',
              paddingLeft: '0 !important',
            },
            '& .MuiOutlinedInput-input': {
              textAlign: 'left !important',
              direction: 'ltr',
              paddingLeft: '14px !important',
              paddingRight: '14px !important',
              fontSize: '14px !important',
            },
            '& input[type="date"]': {
              paddingLeft: '14px !important',
              paddingRight: '14px !important',
              textAlign: 'left !important',
              direction: 'ltr',
              fontSize: '14px !important',
              WebkitAppearance: 'none',
              MozAppearance: 'textfield',
            },
            '& input[type="date"]::-webkit-date-and-time-value': {
              textAlign: 'left !important',
              paddingLeft: '0 !important',
              fontSize: '14px !important',
            },
            '& input[type="date"]::-webkit-datetime-edit': {
              textAlign: 'left !important',
              paddingLeft: '0 !important',
              fontSize: '14px !important',
            },
            '& input[type="date"]::-webkit-datetime-edit-fields-wrapper': {
              textAlign: 'left !important',
              paddingLeft: '0 !important',
            },
          }
        : {};

    // date input에 대한 인라인 스타일 (iOS Safari용 - 최고 우선순위)
    const mergedInputProps =
      type === 'date'
        ? {
            ...inputProps,
            style: {
              textAlign: 'left',
              direction: 'ltr',
              paddingLeft: '14px',
              paddingRight: '14px',
              fontSize: '14px',
              WebkitAppearance: 'none',
              ...inputProps?.style,
            },
          }
        : inputProps;

    return (
      <TextField
        fullWidth
        variant="outlined"
        type={type}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        inputRef={ref}
        disabled={disabled}
        inputProps={mergedInputProps}
        {...restProps}
        sx={{
          minWidth: '320px',
          '& .MuiOutlinedInput-root': {
            height: '46px',
            '& fieldset': {
              borderColor: error ? theme.palette.red : theme.palette.grey.line,
            },
            '& input': {
              color: error ? theme.palette.red : 'var(--pp-text-primary)',
              fontSize: '14px',
              '&::placeholder': {
                fontSize: '14px',
                color: error ? 'transparent' : theme.palette.black[1],
                opacity: 1,
              },
            },
            '&.Mui-disabled': {
              borderColor: theme.palette.grey.line,
              backgroundColor: theme.palette.grey.bg,
              '& input': {
                color: 'var(--pp-text-primary)',
                WebkitTextFillColor: 'var(--pp-text-primary)',
              },
            },
          },
          '& .MuiFormHelperText-root': {
            textAlign: 'left',
            margin: '4px 0 0 0',
            fontSize: '12px',
            fontColor: theme.palette.black[1],
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset !important',
            WebkitTextFillColor: '#000 !important',
            transition: 'background-color 5000s ease-in-out 0s',
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px white inset !important',
            WebkitTextFillColor: '#000 !important',
          },
          ...dateInputStyles,
          ...customSx,
        }}
      />
    );
  },
);

export default CustomTextField;
